import React from 'react';
import { useTranslation } from 'react-i18next';
import './ThankYouModal.css';

const ThankYouModal = ({ isOpen, onClose }) => {
  const { t, i18n } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="thank-you-modal-overlay" onClick={onClose}>
      <div className="thank-you-modal" onClick={(e) => e.stopPropagation()} dir={i18n.dir()}>
        <div className="thank-you-modal-content">
          <div className="thank-you-modal-icon">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
          </div>
          <h2 className="thank-you-modal-title">
            {t('thankYouModal.title')}
          </h2>
          <p className="thank-you-modal-message">
            {t('thankYouModal.message')}
          </p>
          <button
            className="thank-you-modal-btn"
            onClick={onClose}
          >
            {t('thankYouModal.button')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ThankYouModal;

